











import { Clients } from "@timesheets/routes-api-common";
import { getSummaryRoleComponentSelectorMixin } from "Components/Summary/SummaryRoleComponentSelector/getSummaryRoleComponentSelectorMixin";

const base = getSummaryRoleComponentSelectorMixin(Clients.All);

export default base.extend({
  name: "ClientsSummaryRoleComponentSelector",

  components: {
    RecruitmentAgencyAdministrationRole: () => import("./Summary/RecruitmentAgencyAdministrationRole/Index.vue"),
    ContractingRole: () => import("./Summary/ContractingRole/Index.vue"),
  },
});
